// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
  text-align: left;
  background-color: white;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: black;
}

/* Genera material styles */

.MuiButton-contained {
  background-color: #E34043 !important;
  box-shadow: none !important;
}

.MuiButton-textPrimary {
  color: #E34043 !important;
  min-width: 0 !important;
  padding: 0 !important;
}

.MuiButton-contained:hover, .MuiButton-textPrimary:hover {
  box-shadow: none !important;
  opacity: 0.5;
}

.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #E34043 !important;
}

.MuiButton-textPrimary:hover {
  background: transparent !important;
}

.Mui-selected {
  background-color: rgba(0, 0, 0, 0.1) !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA,2BAA2B;;AAE3B;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+CAA+C;AACjD","sourcesContent":[".app {\n  text-align: left;\n  background-color: white;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: black;\n}\n\n/* Genera material styles */\n\n.MuiButton-contained {\n  background-color: #E34043 !important;\n  box-shadow: none !important;\n}\n\n.MuiButton-textPrimary {\n  color: #E34043 !important;\n  min-width: 0 !important;\n  padding: 0 !important;\n}\n\n.MuiButton-contained:hover, .MuiButton-textPrimary:hover {\n  box-shadow: none !important;\n  opacity: 0.5;\n}\n\n.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #E34043 !important;\n}\n\n.MuiButton-textPrimary:hover {\n  background: transparent !important;\n}\n\n.Mui-selected {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
